export default __webpack_public_path__ + "static/media/i-interior-1_bcr.20fd73e2.svg";